import {MmfRowState} from '@/model/common/MmfRowState' 

export class MessageDataConversion {
    constructor({
      id= null, 
      fieldName= ``, 
      mmfValue= ``, 
      legacyValue= ``
  } = {}) {
  this.id = id;
  this.fieldName = fieldName;
  this.mmfValue = mmfValue;
  this.legacyValue = legacyValue;
  this.rowState = new MmfRowState()
  }
  }

  export function newEntity() {
    return new MessageDataConversion();
  }

  export function gridFields() {
    return Object.freeze([
        {
          key: 'fieldName',
          label: 'Message Field Name',
          form: {
            type: 'input'
          }
        },
        {
          key: 'mmfValue',
          label: 'MMF Value',
          form: {
            type: 'input'
          }
        },
        {
          key: 'legacyValue',
          label: 'Legacy System Value',
          sortable: true,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new MessageDataConversion()).map(i => 'entity.' + i));
